import type { EnvControllerGetResponse } from 'api/env/Env.schema.ts';
import { GET } from 'common/helpers.ts';
import useSWR from 'swr';

// Hook for cases where we need to handle undefined (e.g., auth gates, non-authenticated contexts)
export const useEnvSuspense = (): EnvControllerGetResponse | undefined => {
  const { data: env, error } = useSWR<EnvControllerGetResponse>(['/env'], GET, { suspense: true });
  if (error) console.error(error);
  return env;
};

// main hook for authenticated routes where we know env will never be undefined due to suspense
export const useEnv = (): EnvControllerGetResponse => {
  const env = useEnvSuspense();
  // This should never happen due to Suspense,
  // but we'll throw an error to catch any misuse during development
  if (!env) {
    throw new Error('useEnv() called before env data is loaded. Use useEnvSuspense() if you need to handle undefined.');
  }
  return env;
};
